import { useLeaguePageAware } from "./useLeague";

/**
 * Determines whether the current performer belongs to the MLB league.
 * @returns true if the current performer, if any, is an MLB performer
 */
export const useIsMlb = () => {
  const { isMLB } = useLeaguePageAware();
  return isMLB;
};
